"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAddTrackAnalyticsListener = exports.addTrackAnalyticsListener = exports.trackAnalytics = void 0;

var _urlHelper = require("../../helpers/url-helper");

var _urlBuilder = _interopRequireDefault(require("../../helpers/url-builder"));

var trackAnalytics = function trackAnalytics() {
  var dataObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var searchParams = (0, _urlBuilder["default"])((0, _urlHelper.buildQueryString)(dataObj)); // CustomEvent not compatible with IE 10.1 and below
  // eslint-disable-next-line

  var evt = new CustomEvent('trackAnalytics', {
    detail: {
      searchParams: searchParams,
      dataObj: dataObj
    }
  });
  window.dispatchEvent(evt);
};

exports.trackAnalytics = trackAnalytics;

var addTrackAnalyticsListener = function addTrackAnalyticsListener(eventCallback) {
  return window.addEventListener('trackAnalytics', eventCallback);
};

exports.addTrackAnalyticsListener = addTrackAnalyticsListener;

var removeAddTrackAnalyticsListener = function removeAddTrackAnalyticsListener(eventCallback) {
  return window.removeEventListener('trackAnalytics', eventCallback);
};

exports.removeAddTrackAnalyticsListener = removeAddTrackAnalyticsListener;